import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import WithConsumer from '../context/WithConsumer';

const Login = ({ context }) => {
	
	const ctxLoginOpen = () => context.loginOpen;
	const loginOpen = ctxLoginOpen();
	
	const ctxPasswordResetStep = () => context.passwordResetStep;
	const passwordResetStep = ctxPasswordResetStep();
	
	const ctxUserID = () => context.user.id;
	const userID = ctxUserID();
		
	const ctxFrmMsg = () => context.frmMsg;
	const frmMsg = ctxFrmMsg();
			
	let modalClass = 'c-login';
	if (loginOpen === true) {
		modalClass = 'c-login state-login-active';
	}
	
	let email = '';
	let password = '';
	let code = '';
	
    function submitLogin(evt) {
		evt.preventDefault();
		email = document.getElementsByClassName('c-login__form__input--email')[0].value;
		password = document.getElementsByClassName('c-login__form__input--password')[0].value;
		context.submitLogin(email,password);
	}
	
	function submitPasswordReset(evt) {
		evt.preventDefault();
		email = document.getElementsByClassName('c-login__form__input--reset-email')[0].value;
		code = document.getElementsByClassName('c-login__form__input--reset-code')[0].value;
		password = document.getElementsByClassName('c-login__form__input--reset-password')[0].value;
		context.submitPasswordReset(passwordResetStep, email,code,password);
	}
	
	function toggleLogin(evt) {
		evt.preventDefault();
		context.toggleLogin();
	}
	
	function togglePasswordReset(evt) {
		evt.preventDefault();
		context.togglePasswordReset();
	}
	
	function FormMessage() {
		if (frmMsg !== '' && typeof frmMsg !== 'undefined') {
			return (<p className="c-login__message">{ frmMsg }</p>);
		} else {
			return null;
		}
	}
	
    if (passwordResetStep === -1 && (userID === false || userID === undefined || userID === -1)) {
		return (
			<div className={modalClass}>
				<a href="#" className="c-login__overlay" onClick={toggleLogin}></a>
				<div className="c-login__panel">
					<a href="#" className="c-login__close" onClick={toggleLogin}></a>
					<h3 className="c-login__heading">Login to your account</h3>
					<form className="c-login__form" onSubmit={submitLogin}>
						<input className="c-login__form__input c-login__form__input--email" type="email" onChange={event => (email = event.target.value)} placeholder="Email" />
						
						<input className="c-login__form__input c-login__form__input--password" type="password" onChange={event => (password = event.target.value)} placeholder="Password" />
						<a href="#" className="c-login__form__reset" onClick={togglePasswordReset}>Reset your password</a>
						<input className="c-login__form__button" type="submit" value="Login" />
						<FormMessage></FormMessage>
					</form>
					<p className="c-login__cta c-login__cta--top">New to Bloomingdales?</p>
					<p className="c-login__cta c-login__cta--bottom"><Link to={{ pathname: '/customer-registration/' }}>Register for an account</Link></p>
				</div>
			</div>
		)
	} else if (userID === false || userID === undefined || userID === -1) {
		return (
			<div className={modalClass}>
				<a href="#" className="c-login__overlay" onClick={toggleLogin}></a>
				<div className="c-login__panel">
					<a href="#" className="c-login__close" onClick={toggleLogin}></a>
					<h3 className="c-login__heading">Reset Your Password</h3>
					<form className="c-login__form" onSubmit={submitPasswordReset}>
						<input className="c-login__form__input c-login__form__input--reset-email" type="email" onChange={event => (email = event.target.value)} placeholder="Email" disabled={false} />
						{passwordResetStep === 0 &&
							<input className="c-login__form__input c-login__form__input--reset-code" type="text" vale="" disabled={true} />
						}
						{passwordResetStep > 0 &&
							<input className="c-login__form__input c-login__form__input--reset-code" type="text" onChange={event => (code = event.target.value)} placeholder="Verification Code" />
						}
						{passwordResetStep < 2 &&
							<input className="c-login__form__input c-login__form__input--reset-password" type="text" value="" disabled={true} />
						}
						{passwordResetStep === 2 &&
							<input className="c-login__form__input c-login__form__input--reset-password" type="password" onChange={event => (password = event.target.value)} placeholder="New password" />
						}
						
						{passwordResetStep === 0 &&
							<input className="c-login__form__button" type="submit" value="Send Verification Code" />
						}
						{passwordResetStep === 1 &&
							<input className="c-login__form__button" type="submit" value="Verify Code" />
						}
						{passwordResetStep === 2 &&
							<input className="c-login__form__button" type="submit" value="Reset Password & Login" />
						}
						<FormMessage></FormMessage>
					</form>
					<p className="c-login__cta c-login__cta--top">New to Bloomingdales?</p>
					<p className="c-login__cta c-login__cta--bottom"><Link to={{ pathname: '/customer-registration/' }}>Register for an account</Link></p>
				</div>
			</div>
		)
	} else {
		return null;
	}
}
export default WithConsumer(Login);